import { useMemo } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

const FakeCardUserBlock = ({ user }) => {
  const {
    fakeCard: { turnStep, turnUser },
  } = useSelector((state) => state.GameSlice);
  const { userId } = useSelector((state) => state.LoginInfoSlice);

  const kindColors = {
    map: "red",
    ceramic: "blue",
    compass: "yellow",
    coin: "green",
    machete: "orange",
    canteen: "purple",
  };

  const checkTurn = useMemo(
    () => user?.userId === turnUser?.userId,
    [user, turnUser]
  );

  return (
    <Wrap $check={checkTurn}>
      {user.nickname}
      <CardContainer>
        {user.cards?.map((item, index) => {
          const cardColor =
            user.userId === userId || turnStep === 6
              ? kindColors[item?.label]
              : "#e0e0e0";
          return (
            <CardItem
              style={{ backgroundColor: cardColor }}
              key={`${user.userId}${index}userCardKey`}
            ></CardItem>
          );
        })}
      </CardContainer>
    </Wrap>
  );
};

export default FakeCardUserBlock;

const Wrap = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  flex-direction: column;
  border: 1px solid black;
  background-color: ${({ $check }) => ($check ? "#FFFAE0" : "#fff")};
`;

const CardContainer = styled.div`
  width: 100%;
  height: calc(100% - 21px);
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const CardItem = styled.div`
  width: 20px;
  height: 20px;
`;
